import { render, staticRenderFns } from "./PersonaShow.vue?vue&type=template&id=99de24be"
import script from "./PersonaShow.vue?vue&type=script&lang=js"
export * from "./PersonaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports